<mat-toolbar class="topbar topbar-white">
  <!-- Sidenav toggle button -->
  @if (layoutConf.sidebarStyle !== 'compact') {
    <button mat-icon-button id="sidenavToggle" (click)="toggleSidenav()" matTooltip="Toggle Hide/Open">
      <mat-icon>menu</mat-icon>
    </button>
  }
  <!-- Sidenav toggle collapse -->
  @if (layoutConf.sidebarStyle !== 'closed') {
    <button
      mat-icon-button
      id="collapseToggle"
      (click)="toggleCollapse()"
      matTooltip="Toggle Collapse"
      class="header-side__collapse-toggle"
      >
      <mat-icon>chevron_left</mat-icon>
    </button>
  }
  <!-- Search form -->
  <div class="header-side__search-bar">
    <form class="top-search-form">
      <mat-icon role="img">search</mat-icon>
      <input autofocus="true" placeholder="Search" type="text" />
    </form>
  </div>
  <span class="header-side__spacer"></span>
  <!-- Language Switcher -->
  <mat-select placeholder="" id="langToggle" [style.width]="'auto'" name="currentLang" [(ngModel)]="currentLang" (selectionChange)="setLang($event)">
    @for (lang of availableLangs; track lang) {
      <mat-option [value]="lang.code" ngDefaultControl>{{ lang.name }}</mat-option>
    }
  </mat-select>
  <!-- Theme Switcher -->
  <button
    mat-icon-button
    id="schemeToggle"
    [style.overflow]="'visible'"
    matTooltip="Color Schemes"
    [matMenuTriggerFor]="themeMenu"
    class="topbar-button-right"
    >
    <mat-icon>format_color_fill</mat-icon>
  </button>
  <mat-menu #themeMenu="matMenu">
    <mat-grid-list class="theme-list" cols="2" rowHeight="48px">
      @for (theme of egretThemes; track theme) {
        <mat-grid-tile (click)="changeTheme(theme)">
          <div mat-menu-item [title]="theme.name">
            <div [style.background]="theme.baseColor" class="egret-swatch"></div>
            @if (theme.isActive) {
              <mat-icon class="active-icon">check</mat-icon>
            }
          </div>
        </mat-grid-tile>
      }
    </mat-grid-list>
  </mat-menu>
  <!-- Tarifarios toggle button -->
  <button mat-icon-button matTooltip="Tarifarios" (click)="toggleTarifario()" [style.overflow]="'visible'" class="topbar-button-right">
    <mat-icon>dashboard</mat-icon>
  </button>
  <!-- Notification toggle button -->
  <!-- <button mat-icon-button matTooltip="Notifications" (click)="toggleNotific()" [style.overflow]="'visible'" class="topbar-button-right">
  <mat-icon>notifications</mat-icon>
  <span class="notification-number mat-bg-warn">3</span>
</button> -->
<!-- Top left user menu -->
<button mat-icon-button [matMenuTriggerFor]="accountMenu" class="topbar-button-right img-button">
  <img src="assets/images/face-7.jpg" alt="" />
</button>
<mat-menu #accountMenu="matMenu">
  <button mat-menu-item [routerLink]="['/profile/overview']">
    <mat-icon>account_box</mat-icon>
    <span>Profile</span>
  </button>
  <button mat-menu-item [routerLink]="['/profile/settings']">
    <mat-icon>settings</mat-icon>
    <span>Account Settings</span>
  </button>
  <button mat-menu-item>
    <mat-icon>notifications_off</mat-icon>
    <span>Disable alerts</span>
  </button>
  <button mat-menu-item [routerLink]="['/sessions/signin']">
    <mat-icon>exit_to_app</mat-icon>
    <span>Sign out</span>
  </button>
</mat-menu>
</mat-toolbar>
